import { HStack, Spacer, XButton, XDiv, XImage, XTooltip } from "IZOX/_X";
import { ColorX, FIconX } from "IZOX/STATIC";
import { useRef, useState } from "react";
import { FaEye } from "react-icons/fa6";
import { MdClose } from "react-icons/md";

function PreviewIcon({
  file,
  iconSize = 70,
  showDelete,
  onPreview,
  onDelete,
  onHover,
  onHoverOff, 
  color,
  bColor
}){
  const [hover, setHover] = useState(false);
  const ref = useRef(null);

  const onMouseEnter = () => {
    onHover?.();
    setHover(true);
  };

  const onMouseLeave = () => {
    onHoverOff?.();
    setHover(false);
  };

  let {type, link, blob, originalName} = file;
  let icon = type?.includes("image")? 
      <XImage source={link ?? blob} 
        lockWidth={iconSize} 
        lockHeight={iconSize} noResize/> 
      : 
      <HStack 
        lockWidth={iconSize} 
        lockHeight={iconSize}>
          {FIconX.Get(type, iconSize * 0.6, {color: color})}
      </HStack> ;

  let rect = ref?.current?.getBoundingClientRect?.();

  return (
    <XTooltip tooltip={originalName}>
      <HStack lockWidth={iconSize} lockHeight={iconSize}
        forwardRef={ref} bColor={bColor} colorTransition
        bW={1} onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}>
        {icon}
        {hover &&
          <XDiv lockWidth={iconSize} lockHeight={iconSize}
            position="absolute" zIndex={2} style={{top: rect?.top, left: rect?.left}}>
            <HStack fullHeight VAlign="_">
              <XButton onPress={onPreview} padding={5} bgColor={ColorX.CSS("pureDark", 0.3)} colorTransition>
                <FaEye color={ColorX.CSS("aliceblue")}/>
              </XButton>
              <Spacer/>
              {showDelete && 
              <XButton onPress={onDelete} padding={5} bgColor={ColorX.CSS("pureDark", 0.3)} colorTransition>
                <MdClose color={ColorX.CSS("pureRed")}/>
              </XButton>}
            </HStack>
          </XDiv>
          }
      </HStack>
    </XTooltip>
  );
}

export default PreviewIcon;